import React from 'react';

const EmbedForm = ({ formId }) => <div className={`klaviyo-form-${formId}`} />;

export default EmbedForm;
